<kendo-dialog *ngIf="editFormActive" (close)="closeEditForm()" [width]="1400">
    <kendo-dialog-titlebar>
        <h3>{{ (isNew ? 'ADD-BILLABLE-SERVICE' : 'EDIT-BILLABLE-SERVICE') | translate }}</h3>
    </kendo-dialog-titlebar>
    <form novalidate [formGroup]="editForm">
        <!--class="k-form"-->
        <kendo-tabstrip #tabstrip>
            <kendo-tabstrip-tab title="{{ 'BILLABLE-SERVICE' | translate }}" [selected]="true">
                <ng-template kendoTabContent>
                    <div class="pt-3 pl-3 pr-3">
                        <!--name-->
                        <div class="form-group">
                            <div class="row">
                                <div class="col-12">
                                    <label class="k-form-field w-100">
                                        <span class="k-text-uppercase dark">
                                            {{'NAME' | translate}} *
                                        </span>
                                        <input id="name" kendoTextBox formControlName="name" maxlength="100" />
                                        <div class="k-tooltip k-tooltip-validation" role="alert"
                                            *ngIf="name.hasError('required') && name.touched">
                                            {{'REQUIRED-NAME' | translate}}
                                        </div>
                                        <div class="k-tooltip k-tooltip-validation" role="alert"
                                            *ngIf="name.hasError('nameExists')">
                                            {{'BILLABLE-SERVICE-ALREADY-EXISTS' | translate}}
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!--description-->
                        <div class="form-group">
                            <div class="row">
                                <div class="col-12">
                                    <label for="description" class="k-form-field w-100">
                                        <span class="k-text-uppercase dark">
                                            {{ 'DESCRIPTION' | translate }}
                                        </span>
                                        <textarea id="description" kendoTextArea class="w-100 k-textarea" rows="3"
                                            formControlName="description" maxlength="1000" style="max-height: 300px;">
                                        </textarea>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <!--Fee Schedule-->
                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-12">
                                            <label for="feeSchedule" class="k-form-field w-100">
                                                <span class="k-text-uppercase dark">
                                                    {{ 'FEE-SCHEDULE' | translate }} *
                                                </span>
                                                <kendo-combobox class="w-100" formControlName="feeSchedule"
                                                    [data]="feeSchedules" [textField]="'displayName'"
                                                    [valueField]="'id'" [valuePrimitive]="false">
                                                </kendo-combobox>
                                                <div class="k-tooltip k-tooltip-validation" role="alert"
                                                    *ngIf="feeSchedule.hasError('required') && feeSchedule.touched">
                                                    {{'REQUIRED-FEE-SCHEDULE' | translate}}
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-4">
                                <!--Fee Category-->
                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-12">
                                            <label for="feeCategory" class="k-form-field w-100">
                                                <span class="k-text-uppercase dark">
                                                    {{ 'FEE-CATEGORY' | translate }} *
                                                </span>
                                                <kendo-combobox class="w-100" formControlName="feeCategory"
                                                    [data]="feeCategories" [textField]="'displayName'"
                                                    [valueField]="'id'" [valuePrimitive]="false">
                                                </kendo-combobox>
                                                <div class="k-tooltip k-tooltip-validation" role="alert"
                                                    *ngIf="feeCategory.hasError('required') && feeCategory.touched">
                                                    {{'REQUIRED-FEE-CATEGORY' | translate}}
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--Accumulator-->
                            <div class="col-4" *ngIf="!informationalOnly?.value">
                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-12">
                                            <label class="k-form-field w-100">
                                                <span class="k-text-uppercase dark">
                                                    {{ 'ACCUMULATOR' | translate }}
                                                </span>
                                                <kendo-combobox id="accumulator" [data]="accumulatorsFiltered"
                                                    [valueField]="'id'" [textField]="'name'"
                                                    formControlName="accumulator" [filterable]="true"
                                                    [itemDisabled]="accumulatorDisabled"
                                                    (filterChange)="filterAccumulators($event)">
                                                </kendo-combobox>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--external code-->
                        <div class="form-group">
                            <div class="row">
                                <div class="col-4">
                                    <label for="externalCode" class="k-form-field w-100">
                                        <span class="k-text-uppercase dark">
                                            {{ 'BILLABLE-SERVICE-EXTERNAL-CODE' | translate }}
                                        </span>
                                        <input id="externalCode" kendoTextBox formControlName="externalCode"
                                            maxlength="255" />
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <!--Informational Only-->
                            <div class="col-4">
                                <div class="form-group">
                                    <label class="k-text-uppercase dark mr-2" for="enabled">{{ 'INFORMATIONAL-ONLY' |
                                        translate }}
                                    </label>
                                    <kendo-switch formControlName="informationalOnly" onLabel="{{'YES' | translate }}"
                                        offLabel="{{'NO' | translate }}">
                                    </kendo-switch>
                                </div>
                            </div>
                            <!--Manual Amount-->
                            <div class="col-4">
                                <div class="form-group">
                                    <label class="k-text-uppercase dark mr-2" for="enabled">{{ 'MANUAL-AMOUNT' |
                                        translate }}
                                    </label>
                                    <kendo-switch formControlName="manualAmount" onLabel="{{'YES' | translate }}"
                                        offLabel="{{'NO' | translate }}">
                                    </kendo-switch>
                                </div>
                            </div>
                            <!--Enabled-->
                            <div class="col-4">
                                <div class="form-group">
                                    <label class="k-text-uppercase dark mr-2" for="enabled">{{ 'ENABLED' | translate
                                        }}</label>
                                    <kendo-switch formControlName="enabled" onLabel="{{'YES' | translate }}"
                                        offLabel="{{'NO' | translate }}">
                                    </kendo-switch>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab *ngIf="!informationalOnly?.value"
                title="{{ (manualAmount.value ? 'CODES':'RATES') | translate }}">
                <ng-template kendoTabContent>
                    <div class="tab-rates">
                        <div class="p-1">
                            <button kendoButton [primary]="true" (click)="addBillableItem()" type="button" class="mb-2">
                                {{'ADD-RATE' | translate}}<i class="far fa-plus"></i>
                            </button>
                            <div formArrayName="billableItems" class="container-rates">
                                <table class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>
                                                <label class="k-text-uppercase dark font-weight-normal">{{ 'RATE-CODE' |
                                                    translate}} *
                                                </label>
                                            </th>
                                            <th>
                                                <label
                                                    class="k-text-uppercase dark font-weight-normal">{{'MODIFIER-CODES'|
                                                    translate}}
                                                </label>
                                            </th>
                                            <th>
                                                <label class="k-text-uppercase dark font-weight-normal">{{
                                                    'DIAGNOSIS-CODE' | translate}}
                                                </label>
                                            </th>
                                            <th>
                                                <label class="k-text-uppercase dark font-weight-normal">{{
                                                    'DIAGNOSIS-LOOKUP' |
                                                    translate}}
                                                </label>
                                            </th>
                                            <th>
                                                <label *ngIf="!manualAmount.value"
                                                    class="k-text-uppercase dark font-weight-normal">{{ 'RATE' |
                                                    translate}} *
                                                </label>
                                            </th>
                                            <th>
                                                <label class="k-text-uppercase dark font-weight-normal">{{ 'FROM' |
                                                    translate}} *
                                                </label>
                                            </th>
                                            <th>
                                                <label class="k-text-uppercase dark font-weight-normal">{{ 'TO' |
                                                    translate}} *
                                                </label>
                                            </th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let billableItem of editForm.controls.billableItems.controls; let i=index"
                                            [formGroupName]="i">
                                            <td style="width:15%">
                                                <input kendoTextBox formControlName="code" class="w-100"
                                                    maxlength="512" />
                                                <div class="k-tooltip k-tooltip-validation" role="alert"
                                                    *ngIf="editForm.controls.billableItems.controls[i].controls.code.hasError('required') && editForm.controls.billableItems.controls[i].controls.code.touched">
                                                    {{'REQUIRED-SERVICE-CODE' | translate}}
                                                </div>
                                            </td>
                                            <td style="width:13%">
                                                <div class="row">
                                                    <div class="col p-0">
                                                        <input kendoTextBox formControlName="modifierCode"
                                                            maxlength="2" />
                                                    </div>
                                                    <div class="col p-0 ml-1">
                                                        <input kendoTextBox formControlName="modifierCode2"
                                                            maxlength="2" />
                                                    </div>
                                                    <div class="col p-0 ml-1">
                                                        <input kendoTextBox formControlName="modifierCode3"
                                                            maxlength="2" />
                                                    </div>
                                                </div>
                                            </td>
                                            <td style="width:13%">
                                                <input kendoTextBox formControlName="diagnosisCode" class="w-100"
                                                    maxlength="255" />
                                            </td>
                                            <td style="width:18%" class="pl-0 pr-0">
                                                <kendo-multiselect id="extensions" [data]="clientExtensionsFiltered"
                                                    formControlName="extensions" [textField]="'name'"
                                                    [filterable]="true" role="combobox" [valueField]="'id'"
                                                    (filterChange)="filterClientExtensions($event)"
                                                    (close)="searchTerm=''" [autoClose]="true"
                                                    [virtual]="virtualClientExtension" aria-expanded="false"
                                                    aria-controls=".k-list-ul">
                                                    <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                                        <span innerHTML="{{ dataItem.name | highlight : searchTerm }}"
                                                            class="ellipsis-text">
                                                        </span>
                                                    </ng-template>
                                                </kendo-multiselect>
                                            </td>
                                            <td style="width:14%">
                                                <div *ngIf="!manualAmount.value">
                                                    <kendo-numerictextbox id="rate" [format]="'n2'"
                                                        formControlName="rate">
                                                    </kendo-numerictextbox>
                                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                                        *ngIf="editForm.controls.billableItems.controls[i].controls.rate.hasError('required') && editForm.controls.billableItems.controls[i].controls.rate.touched">
                                                        {{'REQUIRED-RATE' | translate}}
                                                    </div>
                                                </div>
                                            </td>
                                            <td style="width:14%">
                                                <kendo-datepicker formControlName="from">
                                                </kendo-datepicker>
                                                <div class="k-tooltip k-tooltip-validation" role="alert"
                                                    *ngIf="editForm.controls.billableItems.controls[i].controls.from.hasError('required') && editForm.controls.billableItems.controls[i].controls.from.touched">
                                                    {{'REQUIRED-FROM' | translate}}
                                                </div>
                                            </td>
                                            <td style="width:14%">
                                                <kendo-datepicker formControlName="to">
                                                </kendo-datepicker>
                                            </td>
                                            <td>
                                                <a title="{{ 'DELETE' | translate }}" (click)="removeBillableItem(i)">
                                                    <i class="fas fa-fw fa-times-circle fa-delete-custom">&nbsp;</i>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
        </kendo-tabstrip>
        <div class="mt-3">* {{'REQUIRED-FIELDS' | translate}}</div>
    </form>
    <kendo-dialog-actions>
        <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
        <button appPreventClick class="k-button k-primary" [disabled]="!editForm.valid || !editForm.dirty"
            (click)="onSave($event)">{{ 'SAVE' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>